import { defineDomainTranslations } from './defineDomainTranslations';

const en = {
  'home.contactSales': 'Contact Sales',
  'home.pricingBanner.choosePlan': 'Choose your plan',
  'home.trialBanner.activeDescriptionDesktop':
    'Unlock full access to translate more videos without limits and use all platform tools',
  'home.trialBanner.activeDescriptionMobile': 'Unlock full access to translate more videos without limits',
  'home.trialBanner.activeTitle': 'Your 3-day trial is ending soon',
  'home.trialBanner.endedDescription': 'Prices are increasing soon! Subscribe today and get:',
  'home.trialBanner.endedTitle': 'Trial has ended, subscribe now with 35% off',
  'home.trialBanner.featureEditor': 'Unlimited redubbing with a powerful editor',
  'home.trialBanner.featureMoreDesktop': 'Lip-sync, Team Spaces, Subtitles and more...',
  'home.trialBanner.featureMoreMobile': 'Lip-sync, Team Spaces and more...',
  'home.trialBanner.featureTranslation': 'High-quality automatic translation in 135+ languages',
  'home.trialBanner.featureVoice': 'Voice Clone in 32 languages',
  'home.trialBanner.getFullAccess': 'Get full access',
  'home.trialBanner.timer.days': 'DAYS',
  'home.trialBanner.timer.hours': 'HRS',
  'home.trialBanner.timer.minutes': 'MIN',
  'home.trialBanner.timer.seconds': 'SEC',
} as const;

type HomeTranslation = Record<keyof typeof en, string>;

const es = {
  'home.contactSales': 'Contactar con ventas',
  'home.pricingBanner.choosePlan': 'Elige tu plan',
  'home.trialBanner.activeDescriptionDesktop':
    'Obtén acceso completo para traducir más videos sin límites y usar todas las herramientas de la plataforma',
  'home.trialBanner.activeDescriptionMobile': 'Obtén acceso completo para traducir más videos sin límites',
  'home.trialBanner.activeTitle': 'Tu prueba de 3 días está a punto de terminar',
  'home.trialBanner.endedDescription': 'Los precios subirán pronto. Suscríbete hoy y obtén:',
  'home.trialBanner.endedTitle': 'La prueba ha terminado: suscríbete ahora con un 35 % de descuento',
  'home.trialBanner.featureEditor': 'Redoblaje ilimitado con un potente editor',
  'home.trialBanner.featureMoreDesktop': 'Lip-sync, espacios de equipo, subtítulos y mucho más...',
  'home.trialBanner.featureMoreMobile': 'Lip-sync, espacios de equipo y mucho más...',
  'home.trialBanner.featureTranslation': 'Traducción automática de alta calidad a más de 135 idiomas',
  'home.trialBanner.featureVoice': 'Clonación de voz en 32 idiomas',
  'home.trialBanner.getFullAccess': 'Obtener acceso completo',
  'home.trialBanner.timer.days': 'DÍAS',
  'home.trialBanner.timer.hours': 'H',
  'home.trialBanner.timer.minutes': 'MIN',
  'home.trialBanner.timer.seconds': 'S',
} satisfies HomeTranslation;

const pt = {
  'home.contactSales': 'Falar com vendas',
  'home.pricingBanner.choosePlan': 'Escolha seu plano',
  'home.trialBanner.activeDescriptionDesktop':
    'Tenha acesso completo para traduzir mais vídeos sem limites e usar todas as ferramentas da plataforma',
  'home.trialBanner.activeDescriptionMobile': 'Tenha acesso completo para traduzir mais vídeos sem limites',
  'home.trialBanner.activeTitle': 'Seu teste de 3 dias termina em breve',
  'home.trialBanner.endedDescription': 'Os preços vão aumentar em breve. Assine hoje e tenha:',
  'home.trialBanner.endedTitle': 'O teste terminou: assine agora com 35% de desconto',
  'home.trialBanner.featureEditor': 'Redublagem ilimitada com um editor poderoso',
  'home.trialBanner.featureMoreDesktop': 'Lip-sync, espaços de equipe, legendas e muito mais...',
  'home.trialBanner.featureMoreMobile': 'Lip-sync, espaços de equipe e muito mais...',
  'home.trialBanner.featureTranslation': 'Tradução automática de alta qualidade em mais de 135 idiomas',
  'home.trialBanner.featureVoice': 'Clonagem de voz em 32 idiomas',
  'home.trialBanner.getFullAccess': 'Obter acesso completo',
  'home.trialBanner.timer.days': 'DIAS',
  'home.trialBanner.timer.hours': 'H',
  'home.trialBanner.timer.minutes': 'MIN',
  'home.trialBanner.timer.seconds': 'S',
} satisfies HomeTranslation;

const fr = {
  'home.contactSales': "Contacter l'équipe commerciale",
  'home.pricingBanner.choosePlan': 'Choisir une offre',
  'home.trialBanner.activeDescriptionDesktop':
    'Obtenez un accès complet pour traduire plus de vidéos sans limite et utiliser tous les outils de la plateforme',
  'home.trialBanner.activeDescriptionMobile': 'Obtenez un accès complet pour traduire plus de vidéos sans limite',
  'home.trialBanner.activeTitle': 'Votre essai de 3 jours se termine bientôt',
  'home.trialBanner.endedDescription': "Les prix vont bientôt augmenter. Abonnez-vous aujourd'hui et profitez de :",
  'home.trialBanner.endedTitle': "L'essai est terminé : abonnez-vous maintenant avec 35 % de réduction",
  'home.trialBanner.featureEditor': 'Redoublage illimité avec un éditeur puissant',
  'home.trialBanner.featureMoreDesktop': "Lip-sync, espaces d'équipe, sous-titres et plus encore...",
  'home.trialBanner.featureMoreMobile': "Lip-sync, espaces d'équipe et plus encore...",
  'home.trialBanner.featureTranslation': 'Traduction automatique de haute qualité dans plus de 135 langues',
  'home.trialBanner.featureVoice': 'Clonage vocal dans 32 langues',
  'home.trialBanner.getFullAccess': "Obtenir l'accès complet",
  'home.trialBanner.timer.days': 'J',
  'home.trialBanner.timer.hours': 'H',
  'home.trialBanner.timer.minutes': 'MIN',
  'home.trialBanner.timer.seconds': 'S',
} satisfies HomeTranslation;

const it = {
  'home.contactSales': 'Contatta il reparto vendite',
  'home.pricingBanner.choosePlan': 'Scegli il tuo piano',
  'home.trialBanner.activeDescriptionDesktop':
    'Ottieni accesso completo per tradurre più video senza limiti e usare tutti gli strumenti della piattaforma',
  'home.trialBanner.activeDescriptionMobile': 'Ottieni accesso completo per tradurre più video senza limiti',
  'home.trialBanner.activeTitle': 'La tua prova di 3 giorni sta per terminare',
  'home.trialBanner.endedDescription': 'I prezzi aumenteranno presto. Abbonati oggi e ottieni:',
  'home.trialBanner.endedTitle': 'La prova è terminata: abbonati ora con il 35% di sconto',
  'home.trialBanner.featureEditor': 'Ridoppiaggio illimitato con un editor potente',
  'home.trialBanner.featureMoreDesktop': 'Sincronizzazione labiale, spazi del team, sottotitoli e altro...',
  'home.trialBanner.featureMoreMobile': 'Sincronizzazione labiale, spazi del team e altro...',
  'home.trialBanner.featureTranslation': 'Traduzione automatica di alta qualità in oltre 135 lingue',
  'home.trialBanner.featureVoice': 'Clonazione vocale in 32 lingue',
  'home.trialBanner.getFullAccess': "Ottieni l'accesso completo",
  'home.trialBanner.timer.days': 'GG',
  'home.trialBanner.timer.hours': 'ORE',
  'home.trialBanner.timer.minutes': 'MIN',
  'home.trialBanner.timer.seconds': 'SEC',
} satisfies HomeTranslation;

const ru = {
  'home.contactSales': 'Связаться с отделом продаж',
  'home.pricingBanner.choosePlan': 'Выбрать тариф',
  'home.trialBanner.activeDescriptionDesktop':
    'Получите полный доступ, чтобы переводить больше видео без ограничений и использовать все инструменты платформы',
  'home.trialBanner.activeDescriptionMobile': 'Получите полный доступ, чтобы переводить больше видео без ограничений',
  'home.trialBanner.activeTitle': 'Ваш трёхдневный пробный период скоро закончится',
  'home.trialBanner.endedDescription': 'Цены скоро вырастут. Оформите подписку сегодня и получите:',
  'home.trialBanner.endedTitle': 'Пробный период закончился — оформите подписку со скидкой 35%',
  'home.trialBanner.featureEditor': 'Неограниченная повторная озвучка в мощном редакторе',
  'home.trialBanner.featureMoreDesktop': 'Липсинк, командные пространства, субтитры и другие функции...',
  'home.trialBanner.featureMoreMobile': 'Липсинк, командные пространства и другие функции...',
  'home.trialBanner.featureTranslation': 'Качественный автоматический перевод более чем на 135 языков',
  'home.trialBanner.featureVoice': 'Клонирование голоса на 32 языках',
  'home.trialBanner.getFullAccess': 'Получить полный доступ',
  'home.trialBanner.timer.days': 'ДН',
  'home.trialBanner.timer.hours': 'Ч',
  'home.trialBanner.timer.minutes': 'МИН',
  'home.trialBanner.timer.seconds': 'СЕК',
} satisfies HomeTranslation;

export const HOME_TRANSLATIONS = defineDomainTranslations({ en, es, fr, it, pt, ru });
